{
  "finder": {
    "searchInput": "finder-search-input",
    "submit": "finder-submit",
    "suggestion": "finder-suggestion",
    "clear": "finder-clear",
    "providerFilter": "finder-provider-filter",
    "providerFilterInput": "finder-provider-filter-input",
    "providerFilterSuggestion": "finder-provider-filter-suggestion",
    "viewToggleList": "finder-view-toggle-list",
    "viewToggleMap": "finder-view-toggle-map",
    "mapContainer": "finder-map-container",
    "mapPanel": "finder-map-panel",
    "mapBoundsSearch": "finder-map-bounds-search",
    "specialtyFilter": "finder-specialty-filter",
    "specialtyFilterInput": "finder-specialty-filter-input",
    "specialtyFilterOption": "finder-specialty-filter-option",
    "visitTypeFilter": "finder-visit-type-filter",
    "visitTypeFilterOption": "finder-visit-type-filter-option",
    "insuranceFilter": "finder-insurance-filter",
    "insuranceFilterInput": "finder-insurance-filter-input",
    "insuranceFilterOption": "finder-insurance-filter-option",
    "distanceFilterInput": "finder-distance-filter-input",
    "distanceFilterOption": "finder-distance-filter-option",
    "distanceSliderInput": "finder-distance-slider-input",
    "dateFilterInput": "finder-date-filter-input",
    "dateFilterDay": "finder-date-filter-day",
    "filterClear": "finder-filter-clear",
    "resultLink": "finder-result-link",
    "sort": "finder-sort",
    "sortToggle": "finder-sort-toggle",
    "sortOption": "finder-sort-option",
    "noResultsMessage": "finder-no-results-message",
    "paginationNext": "finder-pagination-next",
    "paginationPrev": "finder-pagination-prev",
    "sheetSearchInput": "finder-sheet-search-input",
    "mobileMap": "finder-mobile-map",
    "mobileMapBack": "finder-mobile-map-back",
    "mobileMapExternal": "finder-mobile-map-external",
    "showOnMap": "finder-show-on-map",
    "dialogDone": "finder-dialog-done",
    "backToSearch": "finder-back-to-search"
  },
  "insurance": {
    "planActivator": "insurance-plan-activator",
    "networkBadge": "insurance-network-badge"
  },
  "slots": {
    "slot": "slots-slot",
    "fullSchedule": "slots-full-schedule",
    "entrySummary": "slots-entry-summary",
    "pickerSlot": "slots-picker-slot"
  },
  "profile": {
    "backToSearch": "profile-back-to-search",
    "name": "profile-name",
    "locations": "profile-locations",
    "specialties": "profile-specialties",
    "biography": "profile-biography",
    "externalProfessionalRelationships": "profile-external-professional-relationships",
    "insurance": "profile-insurance",
    "ratings": "profile-ratings",
    "features": "profile-features"
  },
  "booking": {
    "patientNew": "booking-patient-new",
    "patientReturning": "booking-patient-returning",
    "ageInRange": "booking-age-in-range",
    "ageOutOfRange": "booking-age-out-of-range",
    "choice": "booking-choice",
    "visitType": "booking-visit-type",
    "select": "booking-select",
    "guest": "booking-guest",
    "next": "booking-next",
    "back": "booking-back",
    "continue": "booking-continue",
    "verifyId": "booking-verify-id",
    "verifyIdError": "booking-verify-id-error",
    "confirmation": "booking-confirmation",
    "error": "booking-error",
    "cancel": "booking-cancel",
    "cancelReason": "booking-cancel-reason",
    "cancelComments": "booking-cancel-comments",
    "cancelSubmit": "booking-cancel-submit",
    "cancelled": "booking-cancelled"
  },
  "registration": {
    "firstName": "registration-first-name",
    "lastName": "registration-last-name",
    "insuranceSameAsLastVisit": "registration-insurance-same-as-last-visit",
    "insuranceChanged": "registration-insurance-changed",
    "insuranceSelfPay": "registration-insurance-self-pay",
    "insuranceReview": "registration-insurance-review",
    "dob": "registration-dob",
    "birthday": "registration-birthday",
    "gender": "registration-gender",
    "ssn": "registration-ssn",
    "email": "registration-email",
    "emailAddress": "registration-email-address",
    "phone": "registration-phone",
    "phoneNumber": "registration-phone-number",
    "street": "registration-street",
    "streetLine2": "registration-street-line-2",
    "city": "registration-city",
    "state": "registration-state",
    "zip": "registration-zip",
    "payor": "registration-payor",
    "memberNumber": "registration-member-number",
    "groupNumber": "registration-group-number",
    "symptoms": "registration-symptoms"
  },
  "login": {
    "email": "login-email",
    "password": "login-password",
    "submit": "login-submit"
  },
  "events": {
    "searchInput": "events-search-input",
    "searchSubmit": "events-search-submit",
    "resultItem": "events-result-item",
    "sessionItem": "events-session-item",
    "showMore": "events-show-more",
    "register": "events-register",
    "continue": "events-continue",
    "payment": "events-payment",
    "confirmation": "events-confirmation",
    "waitlistJoin": "events-waitlist-join",
    "waitlistSubmit": "events-waitlist-submit",
    "waitlisted": "events-waitlisted",
    "resultsList": "events-results-list"
  },
  "pagination": {
    "next": "pagination-next"
  },
  "nav": {
    "hamburger": "nav-hamburger",
    "mobileMenu": "nav-mobile-menu"
  },
  "admin": {
    "indexSearch": "admin-index-search",
    "indexSearchSubmit": "admin-index-search-submit",
    "indexNew": "admin-index-new",
    "indexSort": "admin-index-sort",
    "indexFilters": "admin-index-filters",
    "indexStatusFilter": "admin-index-status-filter",
    "indexTable": "admin-index-table",
    "indexCount": "admin-index-count",
    "indexRecordLink": "admin-index-record-link",
    "settingsPersonalInfo": "admin-settings-personal-info",
    "settingsAddresses": "admin-settings-addresses",
    "providerFirstName": "admin-provider-first-name",
    "providerLastName": "admin-provider-last-name",
    "addAddress": "admin-add-address",
    "addressLine": "admin-address-line",
    "addressCity": "admin-address-city",
    "addressZip": "admin-address-zip",
    "addressState": "admin-address-state",
    "addressEmailTab": "admin-address-email-tab",
    "addEmailAddress": "admin-add-email-address",
    "emailAddress": "admin-email-address",
    "settingsEmployment": "admin-settings-employment",
    "providerNPI": "admin-provider-npi",
    "settingsLicenses": "admin-settings-licenses",
    "addLicense": "admin-add-license",
    "licenseNumber": "admin-license-number",
    "licenseState": "admin-license-state",
    "licensePrimary": "admin-license-primary",
    "settingsCertifications": "admin-settings-certifications",
    "settingsDegrees": "admin-settings-degrees",
    "settingsSpecialties": "admin-settings-specialties",
    "addCertification": "admin-add-certification",
    "certificationCertificate": "admin-certification-certificate",
    "certificationYear": "admin-certification-year",
    "removeCertification": "admin-remove-certification",
    "degreeSearch": "admin-degree-search",
    "specialtySearch": "admin-specialty-search",
    "assignmentResult": "admin-assignment-result",
    "assignmentItem": "admin-assignment-item",
    "indexRow": "admin-index-row",
    "indexRecordSelect": "admin-index-record-select",
    "bulkActionsMenu": "admin-bulk-actions-menu",
    "bulkInviteForReview": "admin-bulk-invite-for-review",
    "save": "admin-save",
    "publishStatus": "admin-publish-status",
    "archive": "admin-archive",
    "confirm": "admin-confirm",
    "settingsPatients": "admin-settings-patients",
    "providerJobTitle": "admin-provider-job-title",
    "providerAgeGroup": "admin-provider-age-group",
    "downloadPdf": "admin-download-pdf"
  },
  "profileReview": {
    "open": "profile-review-open",
    "firstName": "profile-review-first-name",
    "lastName": "profile-review-last-name",
    "email": "profile-review-email",
    "send": "profile-review-send",
    "message": "profile-review-message"
  },
  "review": {
    "start": "review-start",
    "listItem": "review-list-item",
    "backToDashboard": "review-back-to-dashboard",
    "status": "review-status",
    "actionMenu": "review-action-menu",
    "cancel": "review-cancel",
    "submit": "review-submit",
    "submitConfirm": "review-submit-confirm",
    "cancelConfirm": "review-cancel-confirm",
    "cancelError": "review-cancel-error",
    "changeset": "review-changeset",
    "changesetEntry": "review-changeset-entry",
    "entryToggle": "review-entry-toggle",
    "partialResolveConfirm": "review-partial-resolve-confirm",
    "endReviewConfirm": "review-end-review-confirm",
    "addComment": "review-add-comment",
    "changesetAddComment": "review-changeset-add-comment",
    "comment": "review-comment",
    "commentInput": "review-comment-input",
    "commentSubmit": "review-comment-submit",
    "resolve": "review-resolve",
    "decline": "review-decline",
    "requestStart": "review-request-start",
    "requestInvitees": "review-request-invitees",
    "requestInviteeOption": "review-request-invitee-option",
    "requestSubmit": "review-request-submit",
    "requestListItem": "review-request-list-item",
    "requestActionMenu": "review-request-action-menu",
    "requestResend": "review-request-resend",
    "requestCancel": "review-request-cancel",
    "requestTab": "review-request-tab",
    "bulkRequestSubmit": "review-bulk-request-submit"
  },
  "assignSpecialties": {
    "termInput": "assign-specialties-term-input",
    "dropzone": "assign-specialties-dropzone",
    "specialtySelect": "assign-specialties-specialty-select",
    "modeSelect": "assign-specialties-mode-select",
    "clientControlToggle": "assign-specialties-client-control-toggle",
    "previewButton": "assign-specialties-preview-button",
    "confirmButton": "assign-specialties-confirm-button",
    "backButton": "assign-specialties-back-button",
    "previewRow": "assign-specialties-preview-row",
    "flagOutcome": "assign-specialties-flag-outcome"
  },
  "canonicalUpdate": {
    "previewRow": "canonical-update-preview-row",
    "confirmButton": "canonical-update-confirm",
    "cancelButton": "canonical-update-cancel",
    "changesCell": "canonical-update-changes"
  },
  "mstBulkActions": {
    "assignControlMode": "mst-bulk-assign-control-mode",
    "specialtySelect": "mst-bulk-assign-specialties-select",
    "assignSpecialtiesMode": "mst-bulk-assign-specialties-mode",
    "clientControlToggle": "mst-bulk-client-control-toggle"
  },
  "cta": {
    "mobileTeaserBar": "cta-mobile-teaser-bar",
    "mobileTeaser": "cta-mobile-teaser",
    "mobileModal": "cta-mobile-modal"
  },
  "clara": {
    "promptInput": "clara-prompt-input",
    "promptSend": "clara-prompt-send",
    "modal": "clara-modal",
    "modalClose": "clara-modal-close",
    "composerInput": "clara-composer-input",
    "composerSend": "clara-composer-send",
    "message": "clara-message",
    "copy": "clara-copy",
    "retry": "clara-retry",
    "regenerate": "clara-regenerate",
    "thumbsUp": "clara-thumbs-up",
    "thumbsDown": "clara-thumbs-down",
    "feedbackComment": "clara-feedback-comment",
    "feedbackSubmit": "clara-feedback-submit",
    "feedbackCancel": "clara-feedback-cancel",
    "scrollToBottom": "clara-scroll-to-bottom"
  },
  "dtAssistant": {
    "tab": "dt-assistant-tab",
    "componentsTab": "dt-assistant-components-tab",
    "panel": "dt-assistant-panel",
    "composerInput": "dt-assistant-composer-input",
    "composerSend": "dt-assistant-composer-send",
    "attach": "dt-assistant-attach",
    "attachedFile": "dt-assistant-attached-file",
    "updateNotice": "dt-assistant-update-notice",
    "applyAnyway": "dt-assistant-apply-anyway",
    "discard": "dt-assistant-discard",
    "revert": "dt-assistant-revert",
    "revertAnyway": "dt-assistant-revert-anyway",
    "keepChanges": "dt-assistant-keep-changes",
    "warningShow": "dt-assistant-warning-show",
    "warningFix": "dt-assistant-warning-fix"
  },
  "spotlight": {
    "item": "spotlight-item",
    "input": "spotlight-input"
  },
  "createDashboard": {
    "groupTab": "create-dashboard-group-tab",
    "metricTile": "create-dashboard-metric-tile",
    "timelineChart": "create-dashboard-timeline-chart",
    "facetCard": "create-dashboard-facet-card",
    "facetDetailLink": "create-dashboard-facet-detail-link",
    "facetShowAll": "create-dashboard-facet-show-all",
    "facetLegendItem": "create-dashboard-facet-legend-item",
    "facetLegendMenu": "create-dashboard-facet-legend-menu",
    "facetFilterToggle": "create-dashboard-facet-filter-toggle",
    "appliedFilter": "create-dashboard-applied-filter",
    "clearFilters": "create-dashboard-clear-filters",
    "facetDetailBack": "create-dashboard-facet-detail-back",
    "chartTypeBar": "create-dashboard-chart-type-bar",
    "chartTypeLine": "create-dashboard-chart-type-line",
    "settingsMenu": "create-dashboard-settings-menu",
    "viewOptions": "create-dashboard-view-options",
    "percentageToggle": "create-dashboard-percentage-toggle",
    "resetDefaults": "create-dashboard-reset-defaults",
    "viewOptionsDone": "create-dashboard-view-options-done",
    "facetEmpty": "create-dashboard-facet-empty",
    "urlFilterAdd": "create-dashboard-url-filter-add",
    "urlFilterInput": "create-dashboard-url-filter-input",
    "urlFilterDone": "create-dashboard-url-filter-done",
    "urlFilterCancel": "create-dashboard-url-filter-cancel"
  },
  "matchDashboard": {
    "bookingFlowTab": "match-dashboard-booking-flow-tab",
    "bookingFlowChart": "match-dashboard-booking-flow-chart",
    "bookingFlowMetricTile": "match-dashboard-booking-flow-metric-tile",
    "searchBehaviorCard": "match-dashboard-search-behavior-card",
    "searchBehaviorChart": "match-dashboard-search-behavior-chart",
    "metricTile": "match-dashboard-metric-tile",
    "facetCard": "match-dashboard-facet-card",
    "facetLegendItem": "match-dashboard-facet-legend-item",
    "facetLegendMenu": "match-dashboard-facet-legend-menu",
    "facetLegendFilter": "match-dashboard-facet-legend-filter",
    "appliedFilter": "match-dashboard-applied-filter",
    "clearFilters": "match-dashboard-clear-filters",
    "facetDetailLink": "match-dashboard-facet-detail-link",
    "facetDetailBack": "match-dashboard-facet-detail-back",
    "settingsMenu": "match-dashboard-settings-menu",
    "viewOptions": "match-dashboard-view-options",
    "percentageToggle": "match-dashboard-percentage-toggle",
    "viewOptionsDone": "match-dashboard-view-options-done"
  },
  "dateRange": {
    "picker": "date-range-picker",
    "comparePicker": "date-range-compare-picker",
    "shortcutsMenu": "date-range-shortcuts-menu",
    "shortcut": "date-range-shortcut",
    "done": "date-range-done",
    "cancel": "date-range-cancel",
    "compareStart": "date-range-compare-start",
    "compareSwap": "date-range-compare-swap",
    "compareClear": "date-range-compare-clear"
  },
  "scheduleDateGenerator": {
    "trigger": "schedule-date-generator-trigger",
    "dates": "schedule-date-generator-dates",
    "datesDay": "schedule-date-generator-dates-day",
    "startTime": "schedule-date-generator-start-time",
    "endTime": "schedule-date-generator-end-time",
    "duration": "schedule-date-generator-duration",
    "interval": "schedule-date-generator-interval",
    "previewRow": "schedule-date-generator-preview-row",
    "confirm": "schedule-date-generator-confirm",
    "cancel": "schedule-date-generator-cancel"
  },
  "dtBuilder": {
    "arrange": "dt-builder-arrange",
    "internalComment": "dt-builder-internal-comment",
    "internalCommentResolve": "dt-builder-internal-comment-resolve"
  }
}
